module.exports = __webpack_public_path__ + "assets/chat_filled-d052e6.svg";